import {
  Input,
  Component,
  forwardRef,
  OnDestroy,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Subscription } from 'rxjs';

@Component({
  selector: 'tablesready-switcher',
  standalone: false,
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SwitcherComponent),
    },
  ],
})
export class SwitcherComponent implements ControlValueAccessor, OnDestroy {
  @Input() id = '';
  @Input() enabledColor = '#3B76CE';
  @Input() disabledColor = 'gray';

  disabled = false;

  private value = true;
  private onChange = (value: any) => { };
  private onTouched = () => { };
  private readonly subscription = new Subscription();

  get isEnabled(): boolean {
    return this.value;
  }

  toggle(): void {
    if (this.disabled) {
      return;
    }

    this.value = !this.value;

    if (!this.onChange) {
      return;
    }

    this.onChange(this.value);
  }

  registerOnChange(onChange: (_: any) => void): void {
    this.onChange = onChange;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: boolean): void {
    this.value = value;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
